<div class="row">
  @for (dayName of weekDayNames; track dayName) {
    <div class="d-none d-lg-block col day-header text-center">{{dayName}}</div>
  }
</div>
@for (week of weeks; track week) {
  <div class="row">
    @for (day of weekDays; track day) {
      @if (getDate(week, day).getMonth()+1 === month()) {
        <div class="col-12 d-lg-none calendar-day-mobile-header">{{weekDayNames[day]}}</div>
      }
      <div class="col-12 col-lg calendar-day">
        @if (getDate(week, day).getMonth()+1 === month()) {
          <div class="day-container" [style.height]="dayHeight()">
            <ng-container *ngTemplateOutlet="dayTempl(); context: {$implicit: getDate(week,day), data: getData(week,day), dataList: getDataList(week, day)}" />
          </div>
        }
      </div>
    }
  </div>
}